import { Injectable } from '@angular/core';
import { Observable, Subject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class ContainerHeightCalculatorService {
  private subject = new Subject<any>();


  onRecalculate() : Observable<any>{
    return this.subject.asObservable();
  }

  sendRecalculateEventToComponents(recalculate?:boolean,action?:any){
    this.subject.next({ reCalculateHeight : recalculate, action:action });
  }

  calculateHeight(container:string="",classList, randomHeight?){ 
    // container represents the container for which we want to assign the calculated height to
    // classList is an array of classes whose heights needs to be subtracted
    // random height represents the height which we want to subtract when we dont want the container to be till the edge of the page (example: when we want to show top menu when user is in selection mode, then the files will go behind the menu, so we subtract random height to avoid objects to go behind the top menu)
    // globalHeaderPresent is to exclude globalHeaderClassList when globalHeader is not present in view
    var classHeight=0;
    if(classList && classList.length>0){
        classHeight = 0;
        classList.map(cls=>{
            classHeight = classHeight + ($(cls).outerHeight(true)?$(cls).outerHeight(true):0);
        })
    }
    var randHeight = (randomHeight ? randomHeight : 0);
    var finalHeight = $(window).height() - classHeight - randHeight;
    $(container).height(finalHeight);
  }
}
